module.exports = __webpack_public_path__ + "40855f7a60e24e9b3cce71610fe0e1e8.svg";